import { render, staticRenderFns } from "./SidebarTemplate.vue?vue&type=template&id=0fdd6c3a"
import script from "./SidebarTemplate.vue?vue&type=script&lang=js"
export * from "./SidebarTemplate.vue?vue&type=script&lang=js"
import style0 from "./SidebarTemplate.vue?vue&type=style&index=0&id=0fdd6c3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports